import travelSuitcases from './privacy-policy/suitcases.png';

export const IMAGE_ASSETS = {
    travelSuitcases
}